import styled, { css } from 'styled-components';
import { InputContainer } from '../../../_deprecated/input';
import { SelectComponent } from '../../../_deprecated/select';
import { TextAreaContainer } from '../../../_deprecated/textarea';
import { ButtonContainer } from '../../button';
import { pxToRem } from '../../../design-tokens/style-utilities';
export const formContainerFieldSetContainer = ({ theme }) => css `
	display: flex;
	flex-flow: column wrap;
	align-items: flex-start;
	width: 100%;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		flex-flow: row nowrap;

		& > *:not(:last-child) {
			margin-right: ${pxToRem(theme.spacing['100'])};
		}
	}

	${ButtonContainer},
	${InputContainer}:not[type='radio']:not[type='checkbox'],
	${TextAreaContainer},
	${SelectComponent} {
		width: 100%;
		max-width: none;
	}

	/* Use classname to resolve circular dependency */
	.PONCHO-form__field-wrapper {
		min-width: 100%;
	}
`;
export const FormContainerFieldSetContainer = styled.div `
	${formContainerFieldSetContainer}
`;
